import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useContactsForLocation.ts
function useContactsForLocation(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetContactsForLocation.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args?.locationId
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useContactsForLocation };

//# sourceMappingURL=useContactsForLocation.js.map